import { ReactSession } from '../utils/ReactSession.jsx';
import {Navigate} from "react-router-dom";
import {AES, enc} from "crypto-js";
import LegacyDemoPanel from "./LegacyDemoPanel.jsx";
import DemoPanel from "./DemoPanel.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import DemoPanelCloud from "./DemoPanelCloud.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import DemoPage from '../pages/demo/DemoPage.jsx';
import CloudDemoPage from '../pages/demo/CloudDemoPage.jsx';

function Demo(props) {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let dData, bData, pageContent;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (dData.migrated){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            pageContent = isV2 ? <CloudDemoPage /> : <DemoPanelCloud />;
        }else{
            pageContent = isV2 ? <DemoPage /> : <DemoPanel />;
        }
    }
    else{
        pageContent = <LegacyDemoPanel />;
    }

    return (dData?.slauth === true && dData?.tKey != null && dData?.tKey !== "" && dData?.acnt != null && (!compareRole("corporate-admin", dData) || iAmHigherAuthority(99, dData?.role_weight))) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
}

export default Demo;